import React, { useEffect } from 'react';
import { PAGE_CID, PAGE_TITLE } from '@common/const';
import { LxPageView } from '@utils/siteLx';
import loganFn from '@utils/loganFn';
import { getQueryString } from '@utils/tools';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'PageComponent';
}

/**
 * 包装页面组件，做一些公共事物，如记录PV
 * @param WrappedComponent 被包裹的组件
 * @param WrappedComponentName 被包裹的组件名称
 * @return Component 新组件
 */
export default function BasePage(WrappedComponent, WrappedComponentName: string) {
  function NewBasePage(props) {
    // 记录PV
    try {
      LxPageView({ cid: PAGE_CID[WrappedComponentName], valLab: { custom: { source: getQueryString('source') } } });
    } catch (error) {
      console.error(error);
    }
    useEffect(() => {
      loganFn.loganCustomFn(`访问${WrappedComponentName || '未知'}页`);
      loganFn.loganReport();
      // 设置title
      document.title = PAGE_TITLE[WrappedComponentName] || '美团招聘';
      // 是否预览
      if (getQueryString('hash')) {
        document.title = `【预览】${document.title}`;
      }
    }, []);
    return <WrappedComponent {...props} />;
  }
  // 添加displayName名称方便 React Developer Tools 显示
  NewBasePage.displayName = `BasePage(${getDisplayName(WrappedComponent)})`;
  return NewBasePage;
}

/**
 * 正则匹配文字高亮
 *
 */
export function getHighlight(label, keyword) {
  const reg = new RegExp(`(${keyword})`, 'g');
  const labelArr = (label || '')
    .replace(reg, '*$1*')
    .split('*')
    .filter((item) => item !== '');
  return labelArr.map((item) => {
    if (item === keyword) {
      return <span style={{ color: '#FF9D00' }}>{item}</span>;
    }
    return item;
  });
}
